import { createStore } from 'redux'

const initialState = {
  spinner: false,
  imei: null,
  imei_source: null,
  site_id: null,
  auth: {
    username: null,
    authorization: null,
  },
  email: null,
  home_lan: false,
  connectivity_func: null,
  ntt_ae_account: [
    'ntt-ae@test.testdomain'
  ],
  confirmlist: []
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return {...state, ...rest }
    case 'clear': 
      return initialState
    default:
      return state
  }
}

const store = createStore(changeState)
export default store